import {
  expressjs,
  github,
  javascriptImage,
  mongodb,
  Nodejs,
  reactImage,
  tailwindcss,
} from "../constants/images";

const Experience = () => {
  const techStack = [
    {
      id: 3,
      src: javascriptImage,
      title: "JavaScript",
      style: "shadow-yellow-500",
    },

    { id: 5, src: reactImage, title: "ReactJS", style: "shadow-blue-600" },
    { id: 6, src: tailwindcss, title: "TailwindCSS", style: "shadow-teal-500" },
    { id: 7, src: expressjs, title: "ExpressJS", style: "shadow-gray-400" },
    { id: 8, src: mongodb, title: "MongoDB", style: "shadow-green-500" },

    {
      id: 10,
      src: github,
      title: "GitHub",
      style: "shadow-gray-400 bg-gray-900",
    },
    { id: 11, src: Nodejs, title: "NodeJS", style: "shadow-green-500" },
  ];

  return (
    <div
      name="experience"
      className="bg-gradient-to-b from-gray-800 to-black w-full h-full  "
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col my-20 justify-center w-full h-full text-white">
        <div>
          <p className="text-4xl font-bold border-b-4 border-gray-500 p-2 inline">
            Experience
          </p>
          <p className="py-6">These are the technologies I have worked with</p>
        </div>
        <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0">
          {techStack.map(({ id, style, src, title }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-110 duration-500 py-2 rounded-lg ${style}`}
            >
              <img src={src} alt={`${title} logo`} className="w-20 mx-auto" />
              <p className="mt-2">{title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experience;
